module.exports = __webpack_public_path__ + "static/media/diwaliTable.0841ad9c.png";